__turbopack_context__.v({
  "boxOne": "bento-rectangle-four-parts-module-scss-module__YycSNa__boxOne",
  "container": "bento-rectangle-four-parts-module-scss-module__YycSNa__container",
  "copy": "bento-rectangle-four-parts-module-scss-module__YycSNa__copy",
});
